import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Dashboard from "../Dashboard/Dashboard";
import Profileicon from "../../Images/profileimage.png";
import { TiThMenu } from "react-icons/fa";
import MALogo from "../../Images/Icons/ms-logo.png";
import HomeIcon from "../../Images/Icons/home.png";
import DashboardVector from "../../Images/DashboardVector.png";
import CollectionVector from "../../Images/CollectionVector.svg";
import CreateVector from "../../Images/CreateVector.svg";
import CreateNft from "../../Images/EditNft.svg";
import WalletVector from "../../Images/WalletVector.png";
import SettingVector from "../../Images/SettingVector.png";

import {
  CloseIconWrapper,
  Logo,
  MenuIconWrapper,
  MobileIcon,
  MobileIconWrapper,
  MobileLogoWrapper,
  MobileView,
  TextWraper,
} from "../../Components/StyledComponents/MenuListStyledComponents";

const Root = styled.div`
  height: 100vh;
  /* height: 100vh; */
  min-width: 300px;
  background-color: #261327;
  box-shadow: 0 0 49px 0 rgba(0, 0, 0, 0.11);
  position: sticky;
  top: 0px;
  @media (max-width: 905px) {
    min-width: 275px;
  }
  @media (max-width: 768px) {
    display: none;
  }
`;
const LinkWrapper = styled.div`
  padding: 15px 0px 15px 35px;
  display: flex;
  color: #655065;
  font-size: 17px;
  font-weight: bold;
  cursor: pointer;

  ${(p) =>
    p.select &&
    `
    background: linear-gradient(88.96deg, #A73EE7 17.19%, #EB001B 93.38%);
    border-radius: 8px;
    margin: 0 15px;
    padding: 15px 0px 15px 20px;
    cursor: pointer;
   
  `};
`;
const Task = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  left: 15%;
  cursor: pointer;
  font-size: 20px;
  font-weight: 600;
  padding: 13px;
`;
const Link = styled.div`
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #b3b3b3;
  ${(p) =>
    p.select &&
    `
  color:white;
  font-weight:700;
     
  `};
`;

const ImageWrapper = styled.div`
  padding: 3rem 0 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  ${(p) =>
    p.DashBordIconWrapper &&
    `
padding:0 5px;
`}
`;
const Image = styled.img`
  /* width: 103px;
  height: 102px;
  border-radius: 15px;
  box-shadow: 0 0 90px 0 #000;
  border: solid 5px #470747; */

  ${(p) =>
    p.DashboardIcon &&
    `
 width: 25px;
  height: 25px;
  // margin-right:10px;
`}
`;
const ImageIcon = styled.img`
  width: 25px;
  height: 25px;
  margin: 0 10px 0 -30px;
`;
const ImageWrapper1 = styled.div``;

const NameTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 1.5rem;
`;

const NameText = styled.text`
  font-family: Arial;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
  color: #fff;
`;
const AddressText = styled(NameText)`
  font-size: 15px;
  padding: 3px 0;
  color: rgba(255, 255, 255, 0.45);
  background-color: #271327;
`;

const ImageLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const MobileViewAppBar = styled.div`
  width: 100%;
  padding: 10px 20px;
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 80px;
  /* justify-content: right; */
`;

const MenuIcon = styled.div``;
const CloseIcon = styled.div``;

const SmallDeviceLinkView = styled.div`
  background-color: #f1f7f5;
  position: fixed;
  width: 300px;
  right: 0;
  top: 0;
  height: 100vh;
  z-index: 20;
  padding-top: 20px;
  padding-left: 20px;
  box-shadow: 0px 2px 4px -1px rgb(0 0 0 / 20%),
    0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
  @media (min-width: 767px) {
    display: none;
  }
`;
const Icon = styled.img`
  color: white;
`;
const IconWrapper = styled.div`
  padding: 0 10px;
`;

const TextLinkWrapper = styled.div`
  padding: 0 12px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
`;

export const ProfileLeftbar = ({ show, setShow }) => {
  const [selected, setselected] = useState("Dashboard");
  const [showMenuBar, setShowMenuBar] = useState(false);
  const [showNavigation, setShowNavigation] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const params = window.location.href.split("/").pop();
    if (params === "revenuestreams") {
      setselected("Revenue Streams");
    } else if (params === "nftmintdata") {
      setselected("NFTMint Data");
    } else if (params === "listingnft") {
      setselected("Listing Data");
    } else if (params === "createnfts") {
      setselected("CreateNfts");
    } else if (params === "wallet") {
      setselected("Wallet");
    } else if (params === "settings") {
      setselected("Settings");
    } else {
      setselected("Dashboard");
    }
  });
  return (
    <>
      {
        <MenuIconWrapper
          onClick={(e) => {
            e.stopPropagation();
            setShowNavigation(!showNavigation);
          }}
        >
          <i class="fa-solid fa-bars"></i>
        </MenuIconWrapper>
      }

      <Root>
        <ImageWrapper>
          <Image src={Profileicon} />
        </ImageWrapper>
        <NameTextWrapper>
          <NameText>Sushant Tyagi</NameText>
          <AddressText>abc@gmail.com</AddressText>
        </NameTextWrapper>

        <LinkWrapper
          select={selected === "Dashboard"}
          onClick={() => {
            setselected("Dashboard");
            navigate("/dashboard");
          }}
        >
          <IconWrapper>
            <Icon src={DashboardVector} />
          </IconWrapper>

          <TextLinkWrapper>
            <Link select={selected === "Dashboard"}>Dashboard</Link>
          </TextLinkWrapper>
        </LinkWrapper>

        <LinkWrapper
          select={selected === "Revenue Streams"}
          onClick={() => {
            setselected("Revenue Streams");
            navigate("/revenuestreams");
          }}
        >
          <IconWrapper>
            <Icon src={CollectionVector} />
          </IconWrapper>

          <TextLinkWrapper>
            <Link select={selected === "Revenue Streams"}>Revenue Streams</Link>
          </TextLinkWrapper>
        </LinkWrapper>

        <LinkWrapper
          select={selected === "NFTMint Data"}
          onClick={() => {
            setselected("NFTMint Data");
            navigate("/nftmintdata");
          }}
        >
          <IconWrapper>
            <Icon src={CreateVector} />
          </IconWrapper>

          <TextLinkWrapper>
            <Link select={selected === "NFTMint Data"}>NFT Mint Data</Link>
          </TextLinkWrapper>
        </LinkWrapper>

        <LinkWrapper
          select={selected === "Listing Data"}
          onClick={() => {
            setselected("Listing Data");
            navigate("/listingnft");
          }}
        >
          <IconWrapper>
            <Icon src={CollectionVector} />
          </IconWrapper>

          <TextLinkWrapper>
            <Link select={selected === "Listing Data"}> Listing Nft's </Link>
          </TextLinkWrapper>
        </LinkWrapper>

        <LinkWrapper
          select={selected === "CreateNfts"}
          onClick={() => {
            setselected("CreateNfts");
            navigate("/createnfts");
          }}
        >
          <IconWrapper>
            <Icon src={CreateNft} />
          </IconWrapper>

          <TextLinkWrapper>
            <Link select={selected === "CreateNfts"}>Create Nfts</Link>
          </TextLinkWrapper>
        </LinkWrapper>

        <LinkWrapper
          select={selected === "Wallet"}
          onClick={() => {
            setselected("Wallet");
            navigate("/wallet");
          }}
        >
          <IconWrapper>
            <Icon select={selected === "Wallet"} src={WalletVector} />
          </IconWrapper>

          <TextLinkWrapper>
            <Link select={selected === "Wallet"}>Wallet</Link>
          </TextLinkWrapper>
        </LinkWrapper>
        <LinkWrapper
          select={selected === "tokencurrencyconversion"}
          onClick={() => {
            setselected("tokencurrencyconversion");
            navigate("/currencyConversion");
          }}
        >
          <IconWrapper>
            <Icon src={CreateNft} />
          </IconWrapper>

          <TextLinkWrapper>
            <Link select={selected === "tokencurrencyconversion"}>
              Manage Currency
            </Link>
          </TextLinkWrapper>
        </LinkWrapper>
        <LinkWrapper
          select={selected === "Settings"}
          onClick={() => {
            setselected("Settings");
            navigate("/settings");
          }}
        >
          <IconWrapper>
            <Icon src={SettingVector} />
          </IconWrapper>

          <TextLinkWrapper>
            <Link select={selected === "Settings"}>Settings</Link>
          </TextLinkWrapper>
        </LinkWrapper>

        {/* <LinkWrapper
          select={selected === "Logout"}
          onClick={() => {
            navigate("/");
            setShow(false)
          }}
        >
          <Link>Logout</Link>
          </LinkWrapper> */}
      </Root>
      {showNavigation && (
        <MobileView onClick={(e) => e.stopPropagation()}>
          <CloseIconWrapper
            onClick={() => {
              setShowNavigation(!showNavigation);
            }}
          >
            <i class="fa-solid fa-xmark"></i>
          </CloseIconWrapper>
          <MobileLogoWrapper
            selecte={Dashboard === "/"}
            onClick={() => {
              navigate("/");
            }}
          >
            <Logo
              src={MALogo}
              width="60px"
              height="56px"
              top="sm"
              bottom="sm"
            />
          </MobileLogoWrapper>
          <MobileIconWrapper
            selecte={selected === "Dashboard"}
            onClick={() => {
              setselected("Dashboard");
              navigate("/dashboard");
              setShowNavigation(!showNavigation);
            }}
          >
            <MobileIcon src={HomeIcon} width="22px" height="22px" />
            <TextWraper>Profile</TextWraper>
          </MobileIconWrapper>
          <MobileIconWrapper
            selecte={selected === "CreateNfts"}
            onClick={() => {
              navigate("/createnfts");
              setShowNavigation(!showNavigation);
            }}
          >
            <MobileIcon src={HomeIcon} width="22px" height="22px" />
            <TextWraper>CreateNfts</TextWraper>
          </MobileIconWrapper>
          <MobileIconWrapper
            selecte={selected === "Revenue Streams"}
            onClick={() => {
              navigate("/revenuestreams");
              setShowNavigation(!showNavigation);
            }}
          >
            <MobileIcon src={HomeIcon} width="22px" height="22px" />
            <TextWraper>Revenue Streams</TextWraper>
          </MobileIconWrapper>
        </MobileView>
      )}
    </>
  );
};
